// extracted by mini-css-extract-plugin
export var hamburger = "Hamburger-module--hamburger--3bwnQ";
export var light = "Hamburger-module--light--38j3D";